export default __webpack_public_path__ + "static/media/RightFourButton.8c927928.webp";